import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from "@angular/router";
import { Observable, of } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { CommunityService } from "./../data/community.service";


@Injectable({
    "providedIn": "root"
})
export class CommunityResolver implements Resolve<any>{
    private router = inject(Router);
    private communityService = inject(CommunityService);

    resolve (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        const commId = route.paramMap.get("commId");

        return this.communityService.getCommunityById(+commId).pipe(
            tap((comm) => {
                if (!comm) {
                    throw new Error("Community does not exist!");
                }
            }),
            catchError((err, caught) => {
                console.log(err);
                this.router.navigateByUrl("/");
                return of(null);
            })
        );
    }
}
